export default {
  deviceManager: {
    default: 'widescreen',
    devices: [
      {
        id: 'widescreen',
        name: 'Widescreen',
        // Full canvas. Empty widthMedia is required so Style Manager
        // emits unscoped CSS (applies above 1200px; smaller devices override).
        width: '',
        widthMedia: '',
      },
      {
        id: 'desktop',
        name: 'Desktop',
        width: '1200px',
        widthMedia: '1200px',
      },
      {
        id: 'laptop',
        name: 'Laptop',
        width: '992px',
        widthMedia: '992px',
      },
      {
        id: 'tablet',
        name: 'Tablet',
        width: '768px',
        widthMedia: '768px',
      },
      {
        id: 'mobile',
        name: 'Mobile',
        width: '375px',
        widthMedia: '375px',
      },
    ],
  },
}
